import { Injectable } from '@angular/core';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { ISectionsDndEditorConfig, ISectionsSummaryConfig } from '../models/sections-dnd-editor.models';

@Injectable()
export class FiSectionsConfigService {
    private dndEditorConfigs = new Map<ObjectTypes, ISectionsDndEditorConfig>([
        [
            ObjectTypes.CheckpointGroup,
            {
                objectType: ObjectTypes.CheckpointGroup,
                sectionPlaceholder: 'checklist.checkpoints',
                sectionItemsPropName: 'Checkpoints',
                addSectionItemButtonLabel: 'checklist.checkpoint_add',
                sectionEditDialogHeaderTextId: 'checklist.section_edit',
                sectionNewDialogHeaderTextId: 'checklist.section_new',
                deleteSectionDialogHeaderTextId: 'checklist.checkpoint_group_delete',
                deleteSectionDialogMessageTextId: 'checklist.checkpoint_group_delete_confirm_message',
                sectionDialogPanelClasses: ['fi-section-editor-panel', 'fi-rounded-dialog-panel'],
                enableSaveChangesWarning: true,
            },
        ],
        [
            ObjectTypes.TodoSection,
            {
                objectType: ObjectTypes.TodoSection,
                sectionPlaceholder: 'checklist.section',
                sectionItemsPropName: 'Items',
                addSectionItemButtonLabel: 'todo.item_add',
                sectionEditDialogHeaderTextId: 'checklist.section_edit',
                sectionNewDialogHeaderTextId: 'checklist.section_new',
                deleteSectionDialogHeaderTextId: 'checklist.checkpoint_group_delete',
                deleteSectionDialogMessageTextId: 'todo.section_delete_confirm',
                sectionDialogPanelClasses: ['fi-section-editor-panel', 'fi-rounded-dialog-panel'],
                enableSaveChangesWarning: true,
            },
        ],
    ]);

    private summaryConfigs = new Map<ObjectTypes, ISectionsSummaryConfig>([
        [
            ObjectTypes.CheckpointGroup,
            {
                titleTextId: 'checklist.checkpoints_summary',
                itemsLabelSingular: 'checklist.names_of_checkpoints',
                itemsLabelPlural: 'checklist.checkpoints',
                sectionsLabelSingular: 'checklist.section',
                sectionsLabelPlural: 'checklist.add_section',
                sectionItemsPropName: 'Checkpoints',
            },
        ],
        [
            ObjectTypes.TodoSection,
            {
                titleTextId: 'common.summary',
                itemsLabelSingular: 'todo.todo_item',
                itemsLabelPlural: 'todo.todo_items',
                sectionsLabelSingular: 'checklist.section',
                sectionsLabelPlural: 'checklist.add_section',
                sectionItemsPropName: 'Items',
            },
        ],
    ]);

    getDndEditorConfig(objectType: ObjectTypes): ISectionsDndEditorConfig {
        const config = this.dndEditorConfigs.get(objectType);
        if (!config) {
            throw new Error(`No DnD Editor configuration found for object type: ${objectType}`);
        }
        return config;
    }

    getSummaryConfig(objectType: ObjectTypes): ISectionsSummaryConfig {
        const config = this.summaryConfigs.get(objectType);
        if (!config) {
            throw new Error(`No Summary configuration found for object type: ${objectType}`);
        }
        return config;
    }
}
